<template>
    <div :class="divPadding" class="flex items-center">
        <img
            v-if="compact"
            :src="toggleLogoSrc"
            :alt="appName"
            :class="compactImageClass"
        />
        <img
            v-else
            :src="logoSrc"
            :alt="appName"
            :class="imageClass"
        />
    </div>
</template>

<script>
export default {
    name: "logo_invert",
    computed: {
        logoSrc() {
            return this.$store?.state?.settings?.logo_invert || this.$store?.state?.settings?.logo || '/images/default/logo_invert.svg';
        },
        toggleLogoSrc() {
            return this.$store?.state?.settings?.logo_toggle_invert || this.$store?.state?.settings?.logo_toggle || '/images/default/icon.png';
        },
        appName() {
            return this.$store?.state?.settings?.name || 'CORPRED desk';
        },
    },
    props: {
        divPadding: {
            type: String,
            default: 'px-4',
            required: false
        },
        textClass: {
            type: String,
            default: 'text-gray-200',
            required: false
        },
        compact: {
            type: Boolean,
            default: false,
            required: false
        },
        imageClass: {
            type: String,
            default: 'w-auto',
            required: false
        },
        compactImageClass: {
            type: String,
            default: 'w-8 h-8 object-contain',
            required: false
        }
    }
}
</script>
